/**
 * AddOnTool Store
 *
 * Manages Home Screen add-on tools and related lookups.
 */

import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';
import _ from 'lodash';
import { type GetStoreState, type SetStoreState, createStore } from '@seeqdev/utils';
import type { AddOnToolOutputV1 } from '@seeqdev/api/model/AddOnToolOutputV1';

export interface AddOnToolState {
  addOnTools: AddOnToolOutputV1[];
}

const initialState: AddOnToolState = {
  addOnTools: [],
};

const addOnToolActionsFactory = (set: SetStoreState<AddOnToolState>, _get: GetStoreState<AddOnToolState>) => ({
  /**
   * Set Home Screen add-on tools (filters to Homescreen launch location)
   */
  setHomeScreenAddOnTools: (addOnTools: AddOnToolOutputV1[] = []) => {
    const homescreenAddOnTools = _.filter(
      addOnTools,
      (addOnTool) => addOnTool.launchLocation === SeeqNames.API.AddOnToolLaunchLocation.Homescreen,
    );

    set((draft: AddOnToolState) => {
      draft.addOnTools = homescreenAddOnTools;
    });
  },
});

const [AddOnToolStoreProvider, useAddOnToolStoreInstance, useAddOnToolSelector] = createStore(
  'AddOnTool',
  initialState,
  addOnToolActionsFactory,
);

export { AddOnToolStoreProvider };

/**
 * Get add-on tool store's actions
 */
export const useAddOnToolActions = () => useAddOnToolStoreInstance().actions;

/**
 * Get Home Screen add-on tools
 */
export const useHomeScreenAddOnTools = () => useAddOnToolSelector((state) => state.addOnTools);
